export default "./dist/stdassets/images/icons/property.png";